const config = {
  //apiUrl: 'http://172.19.1.51/beta/api',
  //apiUrl: 'http://localhost:60110/',
  //apiUrl: 'https://www.difarmer.com/beta/api'
  //apiUrl: 'http://172.19.4.234/Difarmer.Web.API/',
  //apiUrl: 'http://172.19.4.82:5580',
  apiUrl: 'https://www.difarmer.com/servicio/'
  
}

export default config

